<template>
  <div>
    <ui-heading tag="h5">
      {{ $t("companyProcedures.acceptedDocuments.title") }}
    </ui-heading>
    <div v-if="acceptableDocuments.length">
      <div v-for="(document, index) in acceptableDocuments" :key="index">
        <div v-if="isDocumentAcceptable(document)">
          <section-item
            :item-name="
              translateDocumentType(
                document[ACCEPTABLE_DOCUMENT_FIELDS.DOCUMENT_TYPE]
              )
            "
          />
          <div
            v-if="
              document[ACCEPTABLE_DOCUMENT_FIELDS.DOCUMENT_TYPE] ===
              DOCUMENT_TYPE.LOCAL_PASSPORT
            "
          >
            <ul>
              <li v-for="(item, index) in document.items" :key="index">
                {{
                  $t(`countries.${countryCodes[item.countryIso2]}`) +
                  ` (${item.countryIso2})`
                }}
                <ul>
                  <li
                    v-for="(rule, index) in rulesList(item)"
                    :key="index"
                    class="spaced-item"
                  >
                    {{ translateDocumentRule(rule) }}
                  </li>
                  <li
                    v-if="item[ACCEPTABLE_DOCUMENT_FIELDS.ADDITIONAL_INFO]"
                    class="spaced-item"
                  >
                    {{ $t("companyProcedures.additionalComment") }}
                    <div>
                      <textarea
                        :value="
                          item[ACCEPTABLE_DOCUMENT_FIELDS.ADDITIONAL_INFO][
                            ADDITIONAL_INFO_FIELDS.COMMENT
                          ]
                        "
                        disabled
                        :tabindex="-1"
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div v-else>
            <ul>
              <li v-for="(rule, index) in rulesList(document)" :key="index">
                <div>{{ translateDocumentRule(rule) }}</div>
                <select
                  v-if="
                    rule ===
                      APPLICABLE_RULE.ONLY_SPECIFIC_COUNTRIES_ACCEPTABLE &&
                    document[ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2]
                  "
                  class="acceptable-list"
                  :size="
                    getSelectSize(
                      document[ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2]
                        .length
                    )
                  "
                  :tabindex="-1"
                >
                  <option
                    v-for="(countryCode, index) in document[
                      ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2
                    ]"
                    :key="`acceptableDocument_${index}`"
                    class="country-list-item"
                    disabled
                  >
                    {{
                      $t(`countries.${countryCodes[countryCode]}`) +
                      ` (${countryCode})`
                    }}
                  </option>
                </select>
              </li>
              <li
                v-if="
                  document[ACCEPTABLE_DOCUMENT_FIELDS.ADDITIONAL_INFO] &&
                  document[ACCEPTABLE_DOCUMENT_FIELDS.ADDITIONAL_INFO][
                    ADDITIONAL_INFO_FIELDS.COMMENT
                  ]
                "
                class="spaced-item"
              >
                {{ $t("companyProcedures.additionalComment") }}
                <div>
                  <textarea
                    :value="
                      document[ACCEPTABLE_DOCUMENT_FIELDS.ADDITIONAL_INFO][
                        ADDITIONAL_INFO_FIELDS.COMMENT
                      ]
                    "
                    disabled
                    :tabindex="-1"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="!isAtLeastOneDocumentAcceptable">-</div>
    </div>
    <div v-else>-</div>
  </div>
</template>
<script>
import {
  ACCEPTABLE_DOCUMENT_FIELDS,
  APPLICABLE_RULE,
  ADDITIONAL_INFO_FIELDS,
  DOCUMENT_TYPE
} from "../../constants";
import countryCodes from "../../assets/isoCodes.json";
import {
  getSelectSize,
  isCountryInTheList,
  isEmpty,
  translateDocumentRule,
  translateDocumentType
} from "./utils";
import SectionItem from "./SectionItem";

export default {
  components: { SectionItem },
  props: {
    acceptableDocuments: { type: Array, default: null },
    countryFilterCode: { type: String, default: null }
  },
  watch: {
    countryFilterCode: function () {
      this.isAtLeastOneDocumentAcceptable = false;
    }
  },
  data() {
    return {
      ACCEPTABLE_DOCUMENT_FIELDS,
      APPLICABLE_RULE,
      ADDITIONAL_INFO_FIELDS,
      DOCUMENT_TYPE,
      countryCodes,
      isAtLeastOneDocumentAcceptable: false
    };
  },

  methods: {
    translateDocumentType,
    translateDocumentRule,
    isCountryInTheList,
    isEmpty,
    getSelectSize,
    rulesList: function (document) {
      const rulesList = document[ACCEPTABLE_DOCUMENT_FIELDS.APPLICABLE_RULES];
      const countriesList =
        document[ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2];
      const shouldHideListItem = isCountryInTheList(
        this.countryFilterCode,
        countriesList
      );

      return shouldHideListItem
        ? rulesList.filter(
            rule => rule !== APPLICABLE_RULE.ONLY_SPECIFIC_COUNTRIES_ACCEPTABLE
          )
        : rulesList;
    },
    isDocumentAcceptable: function (document) {
      if (
        this.isEmpty(this.countryFilterCode) ||
        !document[ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2] ||
        (!!document[ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2] &&
          this.isCountryInTheList(
            this.countryFilterCode,
            document[ACCEPTABLE_DOCUMENT_FIELDS.COUNTRIES_ISO_2]
          ))
      ) {
        this.isAtLeastOneDocumentAcceptable = true;

        return true;
      }
    }
  }
};
</script>
<style scoped>
.acceptable-list {
  margin-bottom: 1rem;
}
.spaced-item {
  margin: 0.5rem 0;
}
textarea {
  width: 80%;
  padding: 0.5rem;
  margin-top: 1rem;
  resize: vertical;
}
</style>
